import React from 'react';
import PropTypes from 'prop-types';
import { ElementPaginator, DotsPaginator } from './style';

const ItemDots = ({ className }) => (
  <ElementPaginator className={className}>
    <DotsPaginator>...</DotsPaginator>
  </ElementPaginator>
);

ItemDots.propTypes = {
  className: PropTypes.string
};

export default ItemDots;
